import { useMutation } from 'react-apollo';

import {
  accountLogin as accountLoginMutation,
  accountUpdate as accountUpdateMutation,
} from '../../../../graphql/mutations/account';
import { albumSlideshowContributeSend as albumSlideshowContributeSendMutation } from '../../../../graphql/mutations/albums';
import { autoContributorInvitationsSend as autoContributorInvitationsSendMutation } from '../../../../graphql/mutations/contributor-assignments';
import { useUploadPermission } from '../../../../apps/pro/services/contributors';

const useSlideshowOnboarding = ({ albumId }) => {
  const { isContributor } = useUploadPermission({
    entityId: albumId,
  });
  const [accountLogin] = useMutation(accountLoginMutation);
  const [accountUpdate] = useMutation(accountUpdateMutation);
  const [albumSlideshowContributeSend] = useMutation(
    albumSlideshowContributeSendMutation,
  );
  const [autoContributorInvitationsSend] = useMutation(
    autoContributorInvitationsSendMutation,
  );
  const onAccountLogin = async (email, password) => {
    await accountLogin({
      variables: {
        input: { email, password },
      },
    });
  };

  const onAccountUpdate = async (accountId, name) => {
    await accountUpdate({
      variables: {
        input: {
          id: accountId,
          name,
        },
      },
    });
  };

  const onAlbumSlideshowContributeSend = async () => {
    const result = await albumSlideshowContributeSend({
      variables: {
        input: {
          album_id: albumId,
        },
      },
    });

    return result ?? {};
  };

  const onAutoContributorInvitationsSend = async phoneNumber => {
    await autoContributorInvitationsSend({
      variables: {
        input: {
          album_id: albumId,
          phone_numbers: [phoneNumber],
        },
      },
    });
  };

  return {
    isContributor,
    onAccountLogin,
    onAccountUpdate,
    onAlbumSlideshowContributeSend,
    onAutoContributorInvitationsSend,
  };
};

export default useSlideshowOnboarding;
